import { classes, st } from './DraggableContainer.st.css';

export interface UseDraggableContainerProps {
  draggable?: boolean;
  dragging?: boolean;
  dragDisabled?: boolean;
  dim?: boolean;
  highlight?: boolean;
}

export function useDraggableContainer(props: UseDraggableContainerProps) {
  const { draggable, dragging, dragDisabled, dim, highlight } = props;

  return {
    className: st(classes.root, {
      draggable,
      dragging,
      dragDisabled,
      dim,
      highlight,
    }),
  };
}
